module.exports = Object.freeze({
    NONE: 0,
    SERVICES: 1,
    PRODUCTS: 2,
    TRAINING: 3,
    VA: 4,
    GENERAL: 5,
    OTHER: 6,
    ACTIVITIES: 7,
});